import { createAction } from '@reduxjs/toolkit'
import mapReducer from './Map.reducer'

export const clearMapState = createAction('map/clear')

export default mapReducer
